export const IMAGE_WIDTH_CAROUSEL = 308;
export const IMAGE_WIDTH_GRID = 500;
export const IMAGE_HEIGHT_CAROUSEL = 246;
export const IMAGE_HEIGHT_GRID = 400;

export const DISH_IMAGE_ZOOM = 1.2;

export const DISH_CARD_CLASSES = {
  image: 'h-[231px] md:h-[246px]',
  card: 'h-[355px] md:h-[370px]',
  cardWithShef: 'h-[385px] md:h-[400px]',
};

export const DISH_CAROUSEL_WRAPPER_CLASSES = {
  card: 'h-[371px] md:h-[386px]',
  cardWithShef: 'h-[401px] md:h-[416px]',
  cardWithShefNoMargin: 'h-[385px] md:h-[400px]',
};
